import { render, staticRenderFns } from "./ButtonRules.vue?vue&type=template&id=56674ac0"
import script from "./ButtonRules.vue?vue&type=script&lang=ts"
export * from "./ButtonRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports